import React from 'react';
import { FiSearch, FiCrosshair, FiFileText } from 'react-icons/fi';
import Reveal from '../../fx/Reveal';
import CascadeGrid from '../../fx/CascadeGrid';

const steps = [
    {
        step: '01',
        icon: <FiSearch size={24} />,
        title: 'Reconnaissance',
        description: "Gather intel on your digital footprint. Identify entry points and attack surfaces.",
        bullets: ['OSINT gathering', 'Asset discovery', 'Technology profiling'],
    },
    {
        step: '02',
        icon: <FiCrosshair size={24} />,
        title: 'Exploitation',
        description: 'Ethically exploit identified vulnerabilities to demonstrate real-world impact and risk.',
        bullets: ['Vulnerability exploitation', 'Access control bypass', 'Post-exploitation activities'],
    },
    {
        step: '03',
        icon: <FiFileText size={24} />,
        title: 'Reporting',
        description: 'Deliver comprehensive reports with clear remediation steps and exec summaries.',
        bullets: ['Detailed findings', 'Risk prioritization', 'Remediation guidance'],
    },
];

const RedTeamMethodology = () => {
    return (
        <section className="relative bg-[#08090f] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                <Reveal className="text-center mb-14">
                    <span className="pill tag inline-flex mb-4">METHODOLOGY</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        How we <span className="text-gradient-red">attack</span>.
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto mt-3 text-lg">
                        A systematic approach to identify vulnerabilities and provide actionable remediation strategies.
                    </p>
                </Reveal>

                <CascadeGrid className="grid grid-cols-1 md:grid-cols-3 gap-6" stagger={140}>
                    {steps.map((s, i) => (
                        <div key={i} className="card p-7 relative overflow-hidden">
                            <div className="absolute top-4 right-5 font-display text-6xl font-bold text-white/5">{s.step}</div>
                            <div className="w-12 h-12 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400 mb-5">
                                {s.icon}
                            </div>
                            <h3 className="font-display text-xl font-semibold mb-3">{s.title}</h3>
                            <p className="text-gray-400 text-sm mb-4 leading-relaxed">{s.description}</p>
                            <ul className="text-sm text-gray-300 space-y-2">
                                {s.bullets.map((b, j) => (
                                    <li key={j} className="flex items-start gap-2">
                                        <span className="text-red-500 mt-0.5">›</span>
                                        <span>{b}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </CascadeGrid>
            </div>
        </section>
    );
};

export default RedTeamMethodology;
